import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {ClientDgSearchResults} from "../models/datagrid-search-results/client.dg-search-results.model";
import {ClientsService} from "../providers/clients.service";
import {AppStateService} from "../providers/app-state.service";
import {take, tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {OrderService} from "../providers/order.service";
import {PaymentMethodP24} from "../models/finance/payment-method.model";

@Injectable()
export class PaymentMethodsResolve implements Resolve<PaymentMethodP24[]> {
  constructor(private orderService: OrderService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PaymentMethodP24[]> {
    return this.orderService.getAvailablePaymentMethods();
  }
}
